import { render, staticRenderFns } from "./NovoCliente.vue?vue&type=template&id=0069ac77&scoped=true"
import script from "./NovoCliente.vue?vue&type=script&lang=js"
export * from "./NovoCliente.vue?vue&type=script&lang=js"
import style0 from "./NovoCliente.vue?vue&type=style&index=0&id=0069ac77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0069ac77",
  null
  
)

export default component.exports